import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { dashboardGuard } from './core/guards/dashboard.guard';

export const routes: Routes = [
  {
    path: 'splash',
    loadComponent: () => import('./modules/auth/splash/splash').then(m => m.Splash)
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/auth/auth.routes').then(m => m.authRoutes)
  },
  {
    path: 'otp',
    loadComponent: () => import('./modules/auth/otp/otp').then(m => m.Otp)
  },
  {
    path: 'admin/login',
    loadComponent: () => import('./modules/auth/admin-login/admin-login').then(m => m.AdminLogin)
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/layout/layout').then(m => m.Layout),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        canActivate: [dashboardGuard],
        loadComponent: () =>
          import('./modules/dashboard/dashboard').then(m => m.Dashboard)
      },
      {
        path: 'dashboard/employee',
        loadComponent: () =>
          import('./modules/dashboard/employee/employee-dashboard.component')
            .then(m => m.EmployeeDashboardComponent)
      },
      {
        path: 'processes',
        canActivate: [roleGuard],
        loadChildren: () =>
          import('./modules/processes/processes.routes').then(m => m.processesRoutes)
      },
      {
        path: 'quality-goals',
        loadChildren: () =>
          import('./modules/quality-goals/quality-goals.routes').then(m => m.qualityGoalsRoutes)
      },
      {
        path: 'internal-audit',
        canActivate: [roleGuard],
        loadChildren: () =>
          import('./modules/internal-audit/internal-audit.routes').then(m => m.internalAuditRoutes)
      },
      {
        path: 'kpis',
        canActivate: [roleGuard],
        loadChildren: () =>
          import('./modules/kpis/kpis.routes').then(m => m.kpisRoutes)
      },
      {
        path: 'risk-management',
        canActivate: [roleGuard],
        loadChildren: () =>
          import('./modules/risk-management/risk-management.routes').then(m => m.riskManagementRoutes)
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./modules/settings/settings.routes').then(m => m.settingsRoutes)
      },
      {
        path: 'system-settings',
        canActivate: [roleGuard],
        loadChildren: () =>
          import('./modules/system-settings/system-settings.routes').then(m => m.systemSettingsRoutes)
      },
      {
        path: 'permissions',
        canActivate: [roleGuard],
        loadChildren: () =>
          import('./modules/permissions/permissions.routes').then(m => m.permissionsRoutes)
      },
      {
        path: 'import',
        loadChildren: () =>
          import('./modules/import/import.routes').then(m => m.importRoutes)
      },
      {
        path: 'unauthorized',
        loadComponent: () =>
          import('./shared/components/empty-state/empty-state').then(m => m.EmptyState)
      }
    ]
  },
  { path: '**', redirectTo: '' }
];